import React, { FunctionComponent } from "react";
import DonutChart from 'react-donut-chart';
//import {Doughnut} from "react-chartjs-2";
const chartData = [
  { label: "Complete Success", value: 70 },
  { label: "Partial Success", value: 20 },
  { label: "Non Working", value: 10 }
];

// const chartData = [
//   { label: "", value: 70 },
//   { label: "", value: 20 },
//   { label: "", value: 10 }
// ];

const COLORS = ["#6842D9", "#E5DAFB", "#F4F0FD"];

export default function DoChart() {
  return (
    <div className="mt-4">
      <DonutChart data={chartData} colors={COLORS} width={270} height={300}/>
    </div>
  );
}


// import DonutChart from 'react-donut-chart';
// import {Doughnut} from "react-chartjs-2";
// import React, { FunctionComponent } from "react";
// const graph = [
//   {
//     label: 'Complete Success',
//     value: 70,
//   },
//   {
//     label: 'Partial Success',
//     value: 20,
//   },
//   {
//     label: 'Non Working',
//     value: 10, 
//   },
// ];

// const plugins = [{
//   beforeDraw: function(chart) {
//    var width = ,
//        height = chart.height,
//        ctx = chart.ctx;
//        ctx.restore();
//        var fontSize = (height / 160).toFixed(2);
//        ctx.font = fontSize + "em sans-serif";
//        ctx.textBaseline = "top";
//        var text = "Foo-bar",
//        textX = Math.round((width - ctx.measureText(text).width) / 2),
//        textY = height / 2;
//        ctx.fillText(text, textX, textY);
//        ctx.save();
//   } 
// }]
// const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
//   const { x, y, payload } = props;

//   return (
//     <g transform={`translate(${x},${y})`}>
//       {/* Add a circle marker for every indicator */}
//       <circle cx={0} cy={-8} r={4} fill="#CBCBCB" />
//       <text x={0} y={0} dy={16} textAnchor="middle" fontSize={10} fill="#666">
//         {payload.value}
//       </text>
//     </g>
//   );
// };

// export default function Chart() {
//   return (
//       <DonutChart
//         data={graph}
//         onMouseEnter={(item) => console.log(`mousing entering: ${item.label}`)}
//         onMouseLeave={(item) => console.log(`mouse leaving: ${item.label}`)}
//         onClick={(item, toggled) =>
//           toggled
//             ? console.log(`selecting: ${item.label}`)
//             : console.log(`unselecting: ${item.label}`)
//         }
//       />
//     );
// }